import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import echarts from "echarts";
import elementui from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/table.scss";
import "./assets/style/global.css";
import "./assets/style/global.scss";
import "./assets/style/element-variables.scss"; //改变主题颜色
import Moment from "moment";
import Vuex from "vuex";
// import "./resgisterServiceWorker";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import constant from "./utils/constants.js";
import utils from "./utils/util.js";
import "./assets/font/font.css";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import "./assets/reset.css";
import "./assets/font/iconfont.css";
import "./assets/rem";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import gojs from "gojs";
import clipboard from "clipboard";
import { loginController } from "@/api/activityController";
import { uploadPointData } from "@/api/home.js";
import { checkPermisson } from "@/common/permission";
import { getSellerInfo, getSeller } from "@/api/sellerController";
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import common from "./common/decrypt";
import commonJS from "./utils/common.js";
import JDTabPermission from "@/components/new/jd-tabs-permission.vue";
// import 'babel-polyfill'

import Es6Promise from "es6-promise";
import JSEncrypt from "@/utils/jsencrypt.min";
import Festivals from "./components/Message/festivals.vue";
import { mapState } from "vuex";

// 懒加载
import VueLazyload from "vue-lazyload";

require("es6-promise").polyfill();

Es6Promise.polyfill();

Vue.prototype.clipboard = clipboard;
//图片拖动排序
import VueDND from "awe-dnd";

Vue.use(VueDND);
Vue.use(Viewer);
Vue.use(VueVideoPlayer);
Vue.use(commonJS);
Vue.component("jd-tabs-permission", JDTabPermission);

Vue.component("festivals", Festivals);
Vue.component("jd-tabs-permission", JDTabPermission);

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

/***************引入gojs为原型函数*************************************/
Vue.prototype.$go = gojs;
Vue.prototype.$make = gojs.GraphObject.make;
// 双击解密
Vue.prototype.$decrypt = common;

//el-input挂载
import onlyNumber from "@/directive/el-input"; //添加此行=>自定义全局指令

Vue.use(onlyNumber); //添加此行=>使用该全局指令

Vue.use(Vuex);

Vue.use(Moment);
Vue.use(elementui, { size: "small", zIndex: 3000 });
Vue.use(echarts);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(constant);
Vue.use(utils);

// 懒加载
Vue.use(VueLazyload, {
  // ""懒加载默认图片路径
  // loading: require(""),
});

// Vue.prototype.jq = jquery

Vue.prototype.moment = Moment;

Vue.prototype.$echarts = echarts;

Vue.prototype.$myVue = Vue;

Vue.config.productionTip = false;

Vue.prototype.bus = new Vue();

Vue.filter("numberThree", (val) => {
  return Number(val).toLocaleString();
});

const VUE = this;

Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  },
});
// 输入框只能输入正整数
Vue.directive("numZOnly", {
  bind(el) {
    el.addEventListener("input", (event) => {
      const inputValue = event.target.value;
      event.target.value = inputValue.replace(/^(0+)|[^\d]+/g, "");
    });
  },
});

// 输入框只能输入数字
Vue.directive("numeric-only", {
  bind(el) {
    el.addEventListener("input", (event) => {
      const inputValue = event.target.value;
      const filteredValue = inputValue.replace(/[^\d.]/g, "");
      event.target.value = filteredValue;
    });
  },
});

let maidian = (value) => {
  // console.log(value);
  if (window._hmt) {
    window._hmt.push([
      "_trackEvent",
      "按钮点击",
      "click",
      `${value.from}-${value.name}`,
    ]);
  }
};
// 按钮埋点
Vue.directive("zoom", {
  inserted(el, binding) {
    el.onclick = () => maidian(binding.value);
  },

  update(el, binding) {
    let old = binding.oldValue.from;
    let newV = binding.value.from;
    if (old != newV) {
      // console.log(el);
      // el.removeEventListener('click', ()=>maidian(binding.oldValue),false)
      el.onclick = false;
      el.onclick = () => maidian(binding.value);
    }
  },
});
// 标签埋点
Vue.directive("labelZoom", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (window._hmt) {
        window._hmt.push([
          "_trackEvent",
          "标签选择",
          "active",
          `${binding.value.name}`,
        ]);
      }
    });
  },
});

// 定时器标识
let timer = null;
let timeEnter = null;
let times = 0;

// 埋点计时器
Vue.prototype.setIntervalFun = async function (
  name,
  firstClassify,
  secondClassify,
  id
) {
  if (!id) return;
  timer = setTimeout(() => {
    times = times + 1;
    // 页面停留超过1小时，停止埋点
    if (times >= 3600) {
      // console.log(times);
      this.clearBuriedPoint();
      // console.log('停止埋点');
      return;
    }
    this.buriedPointTimes(name, firstClassify, secondClassify, id);
    // console.log('埋点成功', name, firstClassify, secondClassify);
  }, 2000);
};
// 清除埋点
Vue.prototype.clearBuriedPoint = function () {
  clearTimeout(timer);
};
let route;
// 页面埋点
Vue.prototype.buriedPoint = async function (
  action,
  name,
  firstClassify,
  secondClassify,
  type
) {
  let flage = false;
  if (!flage) {
    this.clearBuriedPoint();
    clearTimeout(timeEnter);
    flage = true;
  }
  if (flage) {
    setTimeout(async () => {
      times = 0;
      var route = this.$route.path;
      let params = {
        platform: "jd",
        venderId: "",
        shopTitle: "",
        source: 0, //来源 0:pc端 1:移动端
        action: action, //类型 1进入页面 2点击按钮 3授权进入 4操作
        url: route, // 路径
        name: name, //"页面/按钮名称（1、2类型时要有）",
        sign: encryptMI(), //JSE加密
        firstClassify: firstClassify, // 一级分类
        secondClassify: secondClassify, // 二级分类
        type: type,
      };
      // 当前店铺信息
      let { data: userInfo } = await getSeller();
      // 指定商家列表  列表中的商家将拥有500个人群策略名额
      var shopList = [
        1000002743, 691846, 1000077584, 87658, 1000007398, 51168, 1000003788,
        1000282702, 1000001782, 1000002591, 1000003111, 1000002983,
      ];
      if (shopList.indexOf(userInfo.venderId) != -1) {
        this.$store.state.peopleNumState = 500;
      } else {
        this.$store.state.peopleNumState = 300;
      }
      if(userInfo.crowdSizeLimit){
        this.$store.state.peopleNumState = userInfo.crowdSizeLimit
      }
      // console.log(userInfo);
      // 当前店铺信息
      params.venderId = userInfo.venderId;
      params.shopTitle = userInfo.shopTitle;
      // 调用埋点
      // console.log(this.$store.state);
      let res = await uploadPointData(params);
      if (res.code) {
        // console.log('埋点成功', res);
        // this.clearBuriedPoint()
        this.buriedPointTimes(name, firstClassify, secondClassify, res.data);
      }
    }, 500);
  }
};

// 轮询埋点
Vue.prototype.buriedPointTimes = async function (
  name,
  firstClassify,
  secondClassify,
  id
) {
  var route = this.$route.path;
  let params = {
    platform: "jd",
    venderId: "",
    shopTitle: "",
    source: 0, //来源 0:pc端 1:移动端
    action: 5, //类型 1进入页面 2点击按钮 3授权进入 4操作
    url: route, // 路径
    name: name, //"页面/按钮名称（1、2类型时要有）",
    sign: encryptMI(), //JSE加密
    firstClassify: firstClassify, // 一级分类
    secondClassify: secondClassify, // 二级分类
    requestId: id, // 请求id
  };
  params.venderId = this.$store.state.loginUserInfo.venderId;
  params.shopTitle = this.$store.state.loginUserInfo.shopTitle;
  // 调用埋点
  let res = await uploadPointData(params);
  // 轮询-埋点
  this.clearBuriedPoint();
  this.setIntervalFun(name, firstClassify, secondClassify, id);
};

// JSEncrypt加密
const encryptMI = function (origin = Date.now()) {
  // 公钥
  const key =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDa+vHCmfKZxVdMBbp69Stu4u11BlOqfEDXK8HqZJ8dKHArYd+78wMzvpQZcWFtdix8MYaTLQERIaxjRoLrGYvYiONi+dKaZ/SSAI8boATYb1Wimz/ocUIGGj2SSZwQ6l5xzOu7orKVdrzUMpqETbuxRwAeMe1ZP/YQ20aXmmGBgwIDAQAB";
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(key);
  return encrypt.encrypt(origin + "");
};

//百度统计代码
var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
  var hm = document.createElement("script");
  hm.src = hm.src =
    "https://hm.baidu.com/hm.js?68e65e77b10e09e3bff6192dcf88de08";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
// console.log(window._hmt);

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
router.beforeEach((to, from, next) => {
  // const resp = await getSellerInfo()
  if (window._hmt) {
    if (to.path) {
      // console.log(to);
      // console.log(from);
      window._hmt.push(["_trackPageview", "/" + to.fullPath]);
    }
  }
  // 忠诚度积分登录
  if (
    to.fullPath.indexOf("integralCenter") != -1 &&
    !store.state.pointUserInfo
  ) {
    getSellerInfo().then((resp) => {
      // 店铺ID
      let venderId = { venderId: resp.data.venderId };
      // 积分登录
      loginController(venderId)
        .then((res) => {
          sessionStorage.setItem("loginValue", res.code);
          if (res && res.code == 1) {
            if (
              res.data.appInfo.status == 1 &&
              res.data.orderInfo.status == 1
            ) {
              // console.log("登录成功");
              store.commit("POINTUSERINFO", res.data.orderInfo);

              // this.editPointUserInfo(res.data.orderInfo)
            } else if (
              res.data.orderInfo.status != 1 &&
              resp.data.subscribeType == 2
            ) {
              let routeUrl = router.resolve({
                path: "/prizeCenter2",
              });
              window.open(routeUrl.href, "_self");
              // window.open("/home", "_self");
            } else if (res.data.orderInfo.status == 1) {
              window.open(res.data.appInfo.authUrl, "_blank");
              window.open("/home", "_self");
            }
          } else {
            if (
              res.data.data.orderInfo.status != 1 &&
              resp.data.subscribeType == 2
            ) {
              let routeUrl = router.resolve({
                path: "/prizeCenter2",
              });
              window.open(routeUrl.href, "_self");
              // window.open("/home", "_self");
            } else if (res.data.data.orderInfo.status == 1) {
              window.open(res.data.data.appInfo.authUrl, "_blank");
              window.open("/home", "_self");
            }
          }
          next();
        })
        .catch((res) => {
          this.$message.error("积分登录失败");
          window.open("/home", "_self");
        });
    });
  } else {
    if (process.env.NODE_ENV == "production" && to.path == "/login") {
      next("/home");
    }
    const routeObj = checkPermisson(to);
    if (!routeObj.next) {
      next();
    } else if (routeObj.path !== "" && routeObj.next) {
      next(routeObj.path);
    }
    // else if(routeObj.path === "" && routeObj.next){
    //   next("/nopermission");
    // }
  }
});
if (window.location.href.indexOf("localhost") > -1) {
  console.log("本地放开打印");
}else {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.dir = function () {};
}

// console.log = function () {};
// console.error = function () {};
// console.dir = function () {};
// console.warn = function () {};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
